import axios from "../axiosConfig";

const baseUrl = process.env.REACT_APP_NINJA_ADMIN_BASE_URL;
const amsBaseUrl = process.env.REACT_APP_AMS_URL;

export const GetAllSalesPersons = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-sales-persons-v1`;
    const data = await axios
      .post(url, body || { input: { limit: 200, offset: 0 } })
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const GetReportingManagerName = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/analytics-report-query-v1`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};


export const GetVerticalsList = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-verticals`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const getSalesPersonAdditionalDetails = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-sales-person-additional-details-v1`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const GetAllVerticalKeys = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-ref-type-relations`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const CreateUpdateSalesPerson = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/add-sales-persons`;
    const data = await axios
      .post(
        url,
        { input: body }
      )
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const uploadCsv = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/request`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const fetchSalesPersonById = async (id) => {
  try {
    const url = `https://${amsBaseUrl}/ams/sales-person/${id}?fetch-sales-hierarchy=true`;
    const res = await axios.get(url);
    return res?.data || {};
  } catch (error) {
    return error;
  }
};

export const fetchSalesPersonByUserId = async (userId) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/analytics-report-query`;
    const body = {
      inputParameters: {
        userId: [userId],
        queryName: "fetch_sales_person",
      },
    };
    const res = await axios.post(url, body);
    return res?.data || {};
  } catch (error) {
    return error;
  }
};

export const salesPersonPositionCodeChange = async (body) => {
  try {
    const url = `https://${amsBaseUrl}/ams/sales-person-to-position-code/remap`;
    const res = await axios.post(url, body);
    return res?.data || {};
  } catch (error) {
    return error;
  }
};

export const fetchCustomers = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-customer-to-position-code-details`;
    const res = await axios.post(url,body);
    return res?.data || {};
  } catch (error) {
    return error;
  }
};

export const getSalesPersonAdditionalDetailsV2 = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/fetch-sales-person-additional-details-v2`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const uploadCustomerToPositionCode = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/bulk-upload-customer-to-position-code`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const getUserDataById = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/trader-realm-filter`;
    const data = await axios
      .post(url, body)
      .then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const getMaxTranferId = async (body) => {
  try {
    const url = `https://${amsBaseUrl}/ams/position-code/maxTransferId`;
    const data = await axios.post(url, body);
    return data;
  } catch (e) {
    return e;
  }
};

export const bulkUploadCustomerToPosition = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/bulk-create-customer-to-position-code`;
    const data = await axios
      .post(url, body)
    return data;
  } catch (error) {
    return error;
  }
};

export const fetchUserRoles = async (input) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/admin-tool-roles-fetch`;
    const body = {
      input,
    };
    const data = await axios.post(url, body);
    return data;
  } catch (error) {
    return error;
  }
};

export const patchRealmRole = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/patch-realm-role`;
    const data = await axios
      .post(url, body)
    return data;
  } catch (error) {
    return error;
  }
};

const tableGridService = {
  GetAllSalesPersons,
  GetReportingManagerName,
  GetVerticalsList,
  GetAllVerticalKeys,
  uploadCsv,
  fetchSalesPersonById,
  fetchSalesPersonByUserId,
  fetchCustomers,
  uploadCustomerToPositionCode,
  getUserDataById,
  getMaxTranferId,
  fetchUserRoles,
  patchRealmRole,
};

export default tableGridService;
